import { api } from '../../core/api.js';

export function listUsers() {
  return api('/users');
}

export function inviteUser(body) {
  return api('/users/invite', { method: 'POST', body });
}

export function updateUser(id, body) {
  return api(`/users/${encodeURIComponent(id)}`, { method: 'PUT', body });
}

export function removeUser(id) {
  return api(`/users/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function activateUser(id) {
  return api(`/users/${encodeURIComponent(id)}/activate`, { method: 'PUT' });
}

/** New password only. Callers must not log or toast the value. */
export function resetPassword(id, body) {
  return api(`/users/${encodeURIComponent(id)}/password`, { method: 'PUT', body });
}

/** @param {'active'|'archived'|'all'} [status] */
export function listProducts(status) {
  const q = status && status !== 'active' ? `?status=${encodeURIComponent(status)}` : '';
  return api(`/products${q}`);
}

export function updateProduct(id, body) {
  return api(`/products/${encodeURIComponent(id)}`, { method: 'PUT', body });
}

export function archiveProduct(id) {
  return api(`/products/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function restoreProduct(id) {
  return api(`/products/${encodeURIComponent(id)}/restore`, { method: 'POST', body: {} });
}

export function listModels() {
  return api('/models');
}

export function listModelKeys() {
  return api('/models/keys');
}

export function setModelEnabled(modelId, enabled) {
  return api(`/models/${encodeURIComponent(modelId)}`, {
    method: 'PUT',
    body: { enabled: !!enabled },
  });
}

export function testProviderKey(provider, apiKey) {
  return api('/models/keys/test', {
    method: 'POST',
    body: { provider, api_key: apiKey },
  });
}

export function deleteProviderKey(provider) {
  return api(`/models/keys/${encodeURIComponent(provider)}`, { method: 'DELETE' });
}

export function setDefaultModel(modelId) {
  return api('/models/default', {
    method: 'PUT',
    body: { model_id: modelId || null },
  });
}

export function publicSupport() {
  return api('/auth/public');
}

export function supportSession() {
  return api('/support/session');
}

export function getWorkspaceSettings() {
  return api('/workspace/settings');
}

/** @param {{ chat_language: string }} body */
export function putWorkspaceSettings(body) {
  return api('/workspace/settings', { method: 'PUT', body });
}
